import axios from "axios";

export default axios.create({
  headers: {
    "Content-Type": "application/json",
  },
  baseURL: process.env.BASE_URL,
  withCredentials: true,
});
